/**
 * Cannot use a namespace here because Typescript namespaces don't support re-exporting for some reason
 */
import { isServerSide } from 'src/utils/validators/isServerSide';
import { areIntegrationTestsRunning } from 'src/utils/validators/areIntegrationTestsRunning';
import { ClientConfigProvider } from '../ClientConfigProvider';

import { RouteConfigurationServiceDomain } from './domain';
export { RouteConfigurationServiceDomain as Domain };
export class ConfigProvider extends ClientConfigProvider {
    public get zillowDomain(): RouteConfigurationServiceDomain.ZillowDomain {
        if (this.runtimeConfig.isLowerEnvironment) {
            return RouteConfigurationServiceDomain.ZillowDomain.NON_PRODUCTION;
        }
        return RouteConfigurationServiceDomain.ZillowDomain.PRODUCTION;
    }

    public get zillowHomeLoansHomePage(): string {
        return `${this.zillowDomain}${RouteConfigurationServiceDomain.ExternalRoute.HOMELOANS_LANDING_PAGE}`;
    }

    public get newUserDestination(): string {
        if (!this.runtimeConfig.isLowerEnvironment || isServerSide() || !areIntegrationTestsRunning()) {
            return `${this.zillowDomain}${RouteConfigurationServiceDomain.ApplicationRoute.MISSING_DASHBOARD}`;
        }
        // return local so Cypress can handle prequal on MRs and staging.
        return RouteConfigurationServiceDomain.ApplicationRoute.MISSING_DASHBOARD;
    }
}
